import { createContext } from 'react';

export const SkeletonContext = createContext<any>({} as any);
